import React, { useState } from "react";
import { Grid, Box, Typography, Link, Button } from "@mui/material";
import { FormProvider, useForm } from "react-hook-form";
import { CustomNumberField, CustomTextField } from "src/components/uiElements";
import { CustomPrimaryButtonFixed } from "src/components/uiElements/buttons/primaryButtonFixed";
import UseSignUp from "src/screens/outerScreens/signup/useSignUp";
import { VerifyOTP } from "src/components/api/user/user";
import SiginInScreen from "../signin/signInScreen";
import ForgotPasswordScreen from "../forgot_password/forgotPasswordScreen";
import VerifyOtpScreen from "../verify_otp/verifyOtpScreen";
import CustomCheckBoxNew from "src/components/uiElements/buttons/customCheckBoxNew";
import RegistrationSuccessScreen from "../registration_success/registrationSuccessScreen";

const SignUpScreen = () => {
  const {
    loading,
    isSignUpOpen,
    IsSignUp,
    onSubmit,
    isUpdate,
    setIsSignInOpen,
    isSignInOpen,
    isRegiSuccess,
    setIsRegiSuccess,
    setIsSignUp,
    setIsSignUpOpen,
    isVerifyOtpScreenOpen,
    setIsVerifyOtpScreenOpen,
    formContext,
    mobileNumber,
    signupData,
  } = UseSignUp();

  const [FirstName, setFirstName] = useState("");
  const [LastName, setLastName] = useState("");
  const [FirmName, setFirmName] = useState("");
  const [MobileNumber, setMobileNumber] = useState("");
  const [EmailID, setEmailID] = useState("");
  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      event.preventDefault(); // Prevent default form submission
      handleButtonClick(); // Trigger form submission
    }
  };

  
  const [isForgotPasswordOpen, setIsForgotPasswordOpen] = useState(false);

  const handleSignUpOpen = () => {
    setIsSignUpOpen(false);
    setIsSignUp(true);
  };

  const handleOtpOpen = () => {
    setIsSignUpOpen(false);
    setIsSignUp(false);
    //setIsVerifyOtpScreenOpen(true);
  };
  const handleSignInOpen = () => {
    setIsSignUpOpen(false);
    setIsForgotPasswordOpen(false);
    setIsSignInOpen(true);
  };

  const handleForgotPasswordOpen = () => {
    setIsForgotPasswordOpen(true);
    setIsSignUpOpen(false);
  };

  const { handleSubmit, getValues } = formContext;

  let values = getValues();

  const handleButtonClick = () => {
    handleSubmit(onSubmit)();
  };

  const [isTandCChecked, setIsTandCChecked] = useState(false);

  return (
    <>
      {isSignUpOpen && (
        <FormProvider {...formContext}>
          <form
            onSubmit={handleSubmit(onSubmit)}
            noValidate
            style={{ width: "100%", padding: "30px" }}
          >
            <Grid
              container
              spacing={0}
              direction="column"
              alignItems="center"
              justifyContent="center"
            >
              <Grid
                item
                xs={3}
                sx={{
                  "@media (max-width: 768px)": {
                    width: "100%",
                  },
                }}
              >
                <Box sx={{ textAlign: "left" }}>
                  <img
                    src="/logo_b.png"
                    width={"170"}
                    style={{ display: "inline" }}
                  />
                </Box>
                <Typography
                  variant="h5"
                  sx={{
                    color: "#000000",
                    textTransform: "titlecase",
                    fontWeight: "700",
                    fontSize: "24px",
                    textAlign: "left",
                    marginTop: "20px",
                    marginBottom: "0px",
                  }}
                >
                  Create your account
                </Typography>
                <Typography
                  variant="h5"
                  sx={{
                    fontSize: "16px",
                    fontWeight: "300",
                    color: "#000000",
                    textAlign: "left",
                    marginBottom: "20px",
                  }}
                >
                  Enter your details or register with Google.
                </Typography>
                <form onSubmit={formContext.handleSubmit(onSubmit)}>
                  <Grid
                    container
                    spacing={1}
                    sx={{
                      justifyContent: "center",
                    }}
                  >
                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                      <CustomTextField
                        required
                        size="small"
                        label={"First Name"}
                        placeholder="First Name"
                        name={"FirstName"}
                        length={60}
                        onChange={(e) => setFirstName(e.target.value)}
                        onKeyPress={handleKeyPress}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                      <CustomTextField
                        required
                        size="small"
                        label={"Last Name"}
                        placeholder="Last Name"
                        name={"LastName"}
                        length={60}
                        onChange={(e) => setLastName(e.target.value)}
                        onKeyPress={handleKeyPress}
                      />
                    </Grid>
                    {/* <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                      <CustomTextField
                        required
                        size="small"
                        label={"Firm Name"}
                        placeholder="Firm Name"
                        name={"FirmName"}
                        length={60}
                        onChange={(e) => setFirmName(e.target.value)}
                        onKeyPress={handleKeyPress}
                      />
                    </Grid> */}
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                      <CustomNumberField
                        required
                        name={"MobileNumber"}
                        size="small"
                        label={"Mobile No."}
                        placeholder="Ex. 9800000000"
                        length={10}
                        onChange={(e) => setMobileNumber(e.target.value)}
                        onKeyPress={handleKeyPress}
                      />
                    </Grid>
                    {/* <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                      <CustomTextField
                        required
                        size="small"
                        label={"Email ID"}
                        placeholder="Email ID"
                        name={"EmailID"}
                        length={60}
                        onChange={(e) => setEmailID(e.target.value)}
                        onKeyPress={handleKeyPress}
                      />
                    </Grid> */}
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                      <Box sx={{display:'inline-block'}}>
                      <CustomCheckBoxNew
                        id={1}
                        checked={isTandCChecked}
                        //onChange={(id, checked) => setIsTandCChecked(checked)}
                        onChange={(id, checked) => {
                          console.log("Checked Value:", checked); // 👈 here
                          setIsTandCChecked(checked);
                        }}                        
                        label={
                          <Box sx={{ fontSize: "14px" }}>
                            I Agree to the{" "}
                            <Box
                              component="a"
                              href="/termsAndConditions"
                              target="_blank"
                              sx={{
                                color: "#6A0DAD",
                                textDecoration: "underline",
                                "&:hover": { textDecoration: "none" },
                              }}
                            >
                              T & C
                            </Box>{" "}
                            and{" "}
                            <Box
                              component="a"
                              href="/privacyPolicy"
                              target="_blank"
                              sx={{
                                color: "#6A0DAD",
                                textDecoration: "underline",
                                "&:hover": { textDecoration: "none" },
                              }}
                            >
                              Privacy Policy
                            </Box>
                          </Box>
                        }
                      />
                      </Box>
                    </Grid>

                    <Grid
                      item
                      xs={12}
                      style={{
                        alignItems: "center",
                        display: "grid",
                      }}
                      sx={{ mt: "14px" }}
                    >
                      <CustomPrimaryButtonFixed
                        style={{
                          fontSize: "20px",
                          fontWeight: 500,
                          justifySelf: "center",
                          width: "100%",
                          opacity: isTandCChecked ? 1 : 0.5,
                          cursor: isTandCChecked ? "pointer" : "not-allowed",
                        }}
                        onClick={
                          IsSignUp ? handleSignUpOpen : handleButtonClick
                        }
                        // title={isUpdate ? "Verify OTP" : "Sign up"}
                        title="Sign up"
                        loading={loading}
                        disabled={!isTandCChecked}
                      />
                    </Grid>

                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          width: "100%",
                          marginTop: "20px",
                        }}
                      >
                        <Box
                          sx={{
                            flex: 1,
                            height: "1px",
                            backgroundColor: "#cccccc",
                          }}
                        />

                        <Typography
                          variant="h6"
                          sx={{
                            mx: 3,
                            fontWeight: 300,
                            fontSize: "14px",
                            color: "#626262",
                            letterSpacing: "2px",
                            textTransform: "uppercase",
                          }}
                        >
                          or Sign In with
                        </Typography>

                        <Box
                          sx={{
                            flex: 1,
                            height: "1px",
                            backgroundColor: "#cccccc",
                          }}
                        />
                      </Box>
                    </Grid>

                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                      <Button
                                                      variant="outlined"
                                                      fullWidth
                                                      startIcon={<img src="/google_icon.svg" width={20} />}
                                                      sx={{
                                                        textTransform: "none",
                                                        borderRadius: "50px",
                                                        marginTop: "10px",
                                                        py: 1.3,
                                                        border: "1px solid #dadce0",
                                                        color: "#000000",
                                                        backgroundColor: "#fff",
                                                        fontSize: "14px",
                                                        fontWeight: 500,
                                                        "&:hover": {
                                                          backgroundColor: "#f7f8f8",
                                                          borderColor: "#6A0DAD",
                                                          color: "#6A0DAD",
                                                        },
                                                      }}
                                                    >
                                                      Sign in with Google
                                                    </Button>
                    </Grid>

                    {/* {isUpdate && (
                      <Grid item xs={12} sx={{ mt: "8px" }}>
                        <CustomTextField
                          fullWidth
                          label={"OTP"}
                          placeholder="OTP"
                          name={"OTP"}
                          type={"OTP"}
                          size="small"
                        />
                      </Grid>
                    )} */}

                    {/* <Grid item xs={12} sx={{ textAlign: "end" }}>
                      <Link
                        onClick={handleForgotPasswordOpen}
                        sx={{
                          textDecoration: "none",
                          fontSize: "14px",
                          color: "#6A0DAD",
                          fontWeight: 300,
                          cursor: "pointer",
                          "&:hover": {
                            color: "#000000",
                          },
                        }}
                      >
                        <span style={{ textDecoration: "underline" }}>
                          Forgot Password?
                        </span>
                      </Link>
                    </Grid> */}

                    <Grid
                      item
                      xs={12}
                      sx={{
                        fontWeight: 300,
                        fontSize: "14px",
                        textAlign: "center",
                        marginTop: "10px",
                      }}
                    >
                      Already have an account?
                      <Link
                        onClick={handleSignInOpen}
                        sx={{
                          textDecoration: "none",
                          fontSize: "14px",
                          color: "#6A0DAD",
                          fontWeight: 300,
                          marginLeft: "5px",
                          cursor: "pointer",
                          "&:hover": {
                            color: "#000000",
                          },
                        }}
                      >
                        <span style={{ textDecoration: "underline" }}>
                          Sign In
                        </span>
                      </Link>
                    </Grid>
                  </Grid>
                </form>
              </Grid>
            </Grid>
          </form>
        </FormProvider>
      )}

      {isForgotPasswordOpen && <ForgotPasswordScreen />}

      {isVerifyOtpScreenOpen && <VerifyOtpScreen mobileNumber={mobileNumber} signupData={signupData} onSuccess={() => { setIsVerifyOtpScreenOpen(false); setIsRegiSuccess(true); }} />}

      {isSignInOpen && <SiginInScreen />}

     {isRegiSuccess && <RegistrationSuccessScreen />}
    </>
  );
};

export default SignUpScreen;
